import { Close } from "@mui/icons-material";
import { Box, Divider, Drawer, IconButton, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const CustomDrawer = ({ open, onClose, title, children }) => {
  const classes = useStyles();
  return (
    <Drawer
      anchor="right"
      classes={{
        root: classes.drawer,
        paper: classes.drawerPaper,
        docked: classes.drawer,
      }}
      open={open}
      onClose={onClose}
      elevation={16}
    >
      <Box className={classes.header}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <Divider />
      <Box className={classes.body}>{children}</Box>
    </Drawer>
  );
};

export default CustomDrawer;
